import { PspContext } from "@/config/contexts";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

export function useAttendanceMobileEmployeeHoursTab() {
  const { lang } = useContext(PspContext);
  const navigate = useNavigate();

  return { lang, navigate };
}
